import { Box, SxProps, Theme, ToggleButton, Tooltip } from "@mui/material";
import { Fragment } from "react";

export function StateToggleButton({
    isSwitchOn,
    onChangeHandle,
    switchOnTooltip,
    switchOffTooltip,
    children,
    sx = undefined,
} : {
    isSwitchOn: boolean,
    onChangeHandle: () => Promise<void>,
    switchOnTooltip: string,
    switchOffTooltip: string,
    children?: React.ReactNode,
    sx?: SxProps<Theme>
}) {
    return (
        <Tooltip
            placement='bottom-start'
            disableInteractive
            arrow
            componentsProps={{
                tooltip: {
                    sx: {
                        maxWidth: '500px'
                    },
                },
            }}
            slotProps={{
                popper: {
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 2],
                            },
                        },
                    ],
                },
            }}
            title={
                <Fragment>
                    <Box sx={{fontSize: "13px"}}>
                        {
                            isSwitchOn
                                ? switchOnTooltip
                                : switchOffTooltip
                        }
                    </Box>
                </Fragment>
            }
        >
            <ToggleButton
                value="check"
                selected={isSwitchOn}
                onChange={onChangeHandle}
                sx={{
                    borderColor: "#9e9d9d",
                    '&.Mui-selected': {
                        backgroundColor: '#cdcdcd',
                    },
                    marginLeft: '-20px',
                    height: '5px',
                    width: '5px',
                    ...sx,
                }}
            >
                {children}
            </ToggleButton>
        </Tooltip>
    );
}